import React from 'react';

const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g fill="none" fillRule="evenodd">
      <circle cx="45" cy="45" r="45" fill="#E8E7E6" />
      <path
        fill="#B2B5B2"
        fillRule="nonzero"
        d="M26.24 62c-.57 0-1.13-.15-1.623-.437a3.254 3.254 0 0 1-1.18-4.44l18.76-32.501a3.234 3.234 0 0 1 5.606 0l18.761 32.501c.286.495.436 1.057.436 1.628A3.244 3.244 0 0 1 63.76 62H26.24z"
      />
      <path
        fill="#E8E7E6"
        fillRule="nonzero"
        d="M47 49h-4V36h4zM47 55h-4v-4h4z"
      />
      <circle
        cx="78"
        cy="78"
        r="11"
        fill="#FFC05F"
        fillRule="nonzero"
        stroke="#F7F5F5"
        strokeWidth="4"
      />
    </g>
  </svg>
);

export default icon;
